
import React from "react";
import { TutorialSection } from "@/types/tutorial";
import TutorialCreationSidebar from "./TutorialCreationSidebar";

interface TutorialCreatorLayoutProps {
  children: React.ReactNode;
  sidebarExpanded: boolean;
  sections: TutorialSection[];
  bomItemCount: number;
  toggleSidebar?: () => void;
}

const TutorialCreatorLayout: React.FC<TutorialCreatorLayoutProps> = ({
  children,
  sidebarExpanded,
  sections,
  bomItemCount,
  toggleSidebar
}) => {
  return (
    <div className="min-h-screen bg-background">
      <div className="flex">
        {/* Sidebar */}
        <div className={`fixed left-0 top-16 bottom-0 z-30 transition-all duration-300 ease-in-out ${
          sidebarExpanded ? 'w-64' : 'w-0'
        } overflow-hidden bg-card border-r border-border`}>
          <TutorialCreationSidebar 
            sections={sections} 
            bomItemCount={bomItemCount}
            expanded={sidebarExpanded}
            onToggle={toggleSidebar}
          />
        </div>

        {/* Main Content */}
        <div className={`flex-1 transition-all duration-300 ease-in-out ${
          sidebarExpanded ? 'ml-64' : 'ml-0'
        }`}>
          <div className="container max-w-4xl mx-auto p-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorialCreatorLayout;
